import { keyMirror } from 'ramda-extension';

export const cardCacheKeys = keyMirror({
	ALL_CARDS: null,
	SINGLE_CARD: null,
	PARTIAL_CARDS: null,
	PAGEABLE_CARDS: null,
});
